// extracted by mini-css-extract-plugin
module.exports = {"root":"Settings_root__1iIu-","search":"Settings_search__2IcMZ","filter":"Settings_filter__2oFAR"};